import { DsdReviewDocument } from "./dsd-review-document";

export const DsdEditorReviewDocument = ({
  documentId,
  closeOnLoadError = false,
}: {
  documentId: string;
  closeOnLoadError?: boolean;
}) => (
  <DsdReviewDocument
    documentId={documentId}
    closeOnLoadError={closeOnLoadError}
  />
);
